import React from "react";
import InheritenceDisplay from "components/InheritenceDisplay";
import StatusIcon from "components/StatusIcon";
import { useFormikContext } from "formik";
import { STATE_KEYS } from "utils/constants/state";
import { STATUS } from "utils/constants/ui";
import classnames from "classnames";
import PropTypes from "prop-types";

const ShippingWorldwideSummary = ({ active, error }) => {
  const { setFieldValue } = useFormikContext();

  return (
    <InheritenceDisplay
      title="Shipping worldwide"
      onRemove={() => {
        setFieldValue(STATE_KEYS.SHORT_LINK.SHIPPING_WORLDWIDE, false);
        setFieldValue(
          `${STATE_KEYS.SHORT_LINK.SHIPPING_ADDRESS_COLLECTION}.allowed_countries`,
          []
        );
      }}
    >
      <div className="flex flex-row justify-between items-center pt2 w-100">
        <label
          className={classnames("f6 word-break pr1", {
            "color-error": error
          })}
        >
          {active ? "Enabled" : "Disabled"}
        </label>
        {active ? (
          <div className="pr1">
            <StatusIcon status={STATUS.SUCCESS} size={20} />
          </div>
        ) : null}
      </div>
    </InheritenceDisplay>
  );
};

ShippingWorldwideSummary.propTypes = {
  active: PropTypes.boolean,
  error: PropTypes.boolean
};

export default ShippingWorldwideSummary;
